import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { DEFAULT_FILTERS, Filters } from '@ifa/types';

function useIsFiltersBtnDisabled(filters: Filters): boolean {
    const methods = useFormContext();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);

    useEffect(() => {
        if (!methods.formState.isDirty) {
            setIsDisabled(JSON.stringify(filters) === JSON.stringify(DEFAULT_FILTERS));
        } else {
            setIsDisabled(JSON.stringify(methods.getValues()) === JSON.stringify(DEFAULT_FILTERS));
        }
    }, [filters, methods]);

    return isDisabled;
}

export default useIsFiltersBtnDisabled;
